// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__3XZZh","title":"card_title__2doz6","text":"card_text__1aQUR","sliderCard":"card_sliderCard__1whdV","carouselCard":"card_carouselCard__2XJsx"};